import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { cuteToast } from "../UI/cute";
import { useState } from "react";


import SingleSlide from "./Single-slide";

// import { cuteToast } from "../UI/cute";

const PreviewSlide = () => {
  const history = useHistory();
  const video_data = useSelector((state) => state.campaign.video_data);
  const camp_id = useSelector((state) => state.campaign.camp_id);
  const [class1, setClass1] = useState("");
  const [class2, setClass2] = useState("");

  const handleShowTemplates = (e) => {
    e.preventDefault();

    if (video_data.length >= 15) {
      cuteToast({
        type: "error",
        message: "",
        timer: 5000,
        title: "Scene max limit is 15",
      });
      return false;
    }
    history.push(`/campaign/${camp_id}/list-templates`);
  };

  const get_lastcharacter = (datastring) => {
    let lastcharacter = datastring.slice(-1);
    return lastcharacter;
  };

  const checkSlide = (single_slide) => {
    // console.log(single_slide.temp_name);
    if( single_slide.temp_name && (single_slide.temp_name.includes("pq_slide_") || single_slide.temp_name.includes("va_slide_") ) && (get_lastcharacter(single_slide.temp_name) === 'v') && class1 !== "product_slideVertical" ){
      setClass1("product_slideVertical");
      setClass2("addNewslidevertical");
    }else{
      if( single_slide.temp_name && (single_slide.temp_name.includes("pq_slide_") || single_slide.temp_name.includes("va_slide_") ) && (get_lastcharacter(single_slide.temp_name) !== 'v') && class1 === "product_slideVertical"){
        setClass1("");
        setClass2("");
      }
    }

  }


  return (
    <div className={`product_slide bg-white  ${class1}`}>
      {/* <h4 className="pb-3">Preview Slides</h4> */}
      <div className="row">
        <div className={`addNewslide ${class2}`}>
          <ul className="preview_slides">
            {video_data &&
              video_data.map((single_slide, key) => (
                  
                <div className="item" key={key}>
                  { checkSlide(single_slide)  }
                  <SingleSlide single_slide={single_slide} key={key} id={key} />
                </div>
              ))}
          </ul>
          <div className="series_vd position-relative addSlides ">
            <a href="#0" onClick={(e) => handleShowTemplates(e)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="50"
                height="50"
                viewBox="0 0 50 50"
                style={{ fill: "#26e07f" }}
              >
                <path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 24 13 L 24 24 L 13 24 L 13 26 L 24 26 L 24 37 L 26 37 L 26 26 L 37 26 L 37 24 L 26 24 L 26 13 L 24 13 z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PreviewSlide;
